var cilArrowThickToLeft = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M336,176V56H297.373l-200,199.8L297.363,456H336V336H496V176ZM464,304H304V417.361L142.625,255.826,304,94.616V208H464Z' class='ci-primary'/><rect width='32' height='400' x='16' y='56' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilArrowThickToLeft };

